/** «Oʻyinlar» tabi (demo v3 `Games`): So'z jangi kartasi + mashq o'yinlari (11 ta), rekordlar. Live stol hozircha yo'q. */
import { useStore, started } from '../../store';
import { nav, type GameKey } from '../../lib/nav';
import { startLesson } from '../lesson/engine';
import { canSpeak } from '../../lib/speech';
import { toast } from '../../lib/toast';
import { fmtTime } from '../../data';
import { FM } from '../../data/forms';
import { t, tn } from '../../i18n';
import { Ic } from '../../ui/Icon';

export const GAME_NAMES: Record<GameKey, string> = {
  cards: 'Kartochkalar', learn: 'Oʻrganish', match: 'Juftlik', test: 'Test', listen: 'Eshit va yoz', gap: 'Boʻsh joy', t60: 'Tezkor 60', meteor: 'Meteor', snake: 'Soʻz ilon',
};
type TileKey = GameKey | 'forms' | 'numbers';

/** [kalit, ikonka, fon, rang, nom, izoh, Pro-qulf] */
const G: Array<[TileKey, string, string, string, string, string, boolean]> = [
  ['cards', 'copy', 'var(--primary-soft)', 'var(--primary-ink)', 'Kartochkalar', 'Aylantiring va eslang', false],
  ['learn', 'book', 'var(--success-soft)', 'var(--success-ink)', 'Oʻrganish', 'Tanlash, keyin yozish', false],
  ['match', 'grid', 'var(--info-soft)', 'var(--info-ink)', 'Juftlik', '6 juftni tez toping', false],
  ['test', 'clip', 'var(--peach-soft)', 'var(--peach-ink)', 'Test', '10 savol, baho', false],
  ['listen', 'head', 'var(--info-soft)', 'var(--info-ink)', 'Eshit va yoz', 'Audio, sekin ijro', false],
  ['gap', 'cursor', 'var(--success-soft)', 'var(--success-ink)', 'Boʻsh joy', 'Gapni toʻldiring', false],
  ['t60', 'timer', 'var(--primary-soft)', 'var(--primary-ink)', 'Tezkor 60', 'Toʻgʻri yoki notoʻgʻri', false],
  ['meteor', 'rocket', 'var(--peach-soft)', 'var(--peach-ink)', 'Meteor', 'Toʻgʻri soʻzni otib tushiring', false],
  ['snake', 'route', 'var(--success-soft)', 'var(--success-ink)', 'Soʻz ilon', 'Harflarni bogʻlab soʻz toping', false],
  ['forms', 'layers', 'var(--info-soft)', 'var(--info-ink)', 'Soʻz shakllari', FM.title, false],
  ['numbers', 'hash', 'var(--primary-soft)', 'var(--primary-ink)', 'Sonlar', 'Eshiting va raqamda yozing', false],
];

export function Games() {
  useStore((s) => s.w); // started() uchun obuna
  const best = useStore((s) => s.best);
  const best60 = useStore((s) => s.best60);
  const bestMet = useStore((s) => s.bestMet);
  const bestNum = useStore((s) => s.bestNum);
  const lvl = useStore((s) => s.lvl);
  const n = started().length;

  const open = (k: TileKey, lock: boolean) => {
    if (lock) return toast(t('Bu oʻyin Pro versiyada boʻladi'));
    if (k === 'learn') return startLesson();
    if (k === 'forms') return nav.push({ k: 'forms', from: 'games' });
    if (k === 'numbers') return nav.push({ k: 'numbers' });
    if (k === 'listen' && !canSpeak()) return toast(t('Bu qurilmada ovoz chiqmaydi'));
    nav.push({ k: 'picker', game: k });
  };

  const badge = (k: TileKey) => {
    if (k === 'numbers' && bestNum.hard != null) return <span className="t12" style={{ color: 'var(--primary-ink)', fontWeight: 800 }}>{tn('Qiyin #/10', bestNum.hard)}</span>;
    if (k === 'match' && best) return <span className="t12" style={{ color: 'var(--info-ink)', fontWeight: 800 }}>{fmtTime(best)}</span>;
    if (k === 't60' && best60) return <span className="t12" style={{ color: 'var(--primary-ink)', fontWeight: 800 }}>{tn('Rekord #', best60)}</span>;
    if (k === 'meteor' && bestMet) return <span className="t12" style={{ color: 'var(--peach-ink)', fontWeight: 800 }}>{tn('Rekord #', bestMet)}</span>;
    return null;
  };

  return (
    <>
      <div className="col g8"><h1 className="h1">{t('Oʻyinlar')}</h1></div>
      <div className="livebig">
        <button onClick={() => nav.push({ k: 'duel' })} style={{ background: 'linear-gradient(150deg,#0B1B3F,#1A66F5)' }}>
          <Ic n="swords" className="i bgi" />
          <i><Ic n="swords" /></i>
          <b>{t('Soʻz jangi')}</b><small>{t('1 ga 1 · doʻst, raqib yoki bot')} · {lvl}</small>
        </button>
      </div>
      <div className="col g8">
        <b className="t16b" style={{ fontSize: 18 }}>{t('Mashq oʻyinlari')}</b>
        <span className="pill card" style={{ height: 'auto', padding: '8px 12px', fontSize: 13, fontWeight: 700, alignSelf: 'flex-start' }}>
          {n >= 6 ? tn('Oʻrganilgan soʻzlar · #', n) : t('Barcha soʻzlardan')}
        </span>
      </div>
      <div className="games">
        {G.map(([k, i, bg, fg, title, d, lock]) => (
          <button key={k} className="game" aria-disabled={lock || undefined} onClick={() => open(k, lock)}>
            <span className="between">
              <span className="ibox" style={{ background: bg, color: fg }}><Ic n={i} /></span>
              {lock ? <span className="pro">PRO</span> : badge(k)}
            </span>
            <span className="col g4"><b className="t15b">{t(title)}</b><span className="t12">{t(d)}</span></span>
          </button>
        ))}
      </div>
      <p className="t12" style={{ margin: 0 }}>{t('Oʻyinlar oʻrganilgan soʻzlaringizdan tuziladi (kamida 6 ta boʻlmasa — barcha soʻzlardan).')}</p>
    </>
  );
}
